// extracted by mini-css-extract-plugin
export default {"services-section":"Services_services-section__cT6FA","service":"Services_service__NSn5W"};